export default {
  menu: 'List of Companies',
  title: 'List of Companies',

  table: {
    header: {
      row: 'Row',
      code: 'Code',
      name: 'Company name',
      equity: 'Capital',
      totalDebt: 'Total debt',
      totalAsset: 'Total assets'
    }
  },

  labels: {
    generalInfo: 'Company General Information',
    telInfo: 'Company information',
    financialInfo: 'Financial information',
    uploadLogo: 'upload logo',
    preview: 'Preview:',
    code: 'company code',
    name: 'company name',
    managerName: 'Manager Name',
    address: 'Address',
    phoneNumber: 'Mobile Number',
    managerPhoneNumber: 'Admin Mobile Number',
    financialFrom: 'Start of the financial year',
    financialTo: 'End of fiscal year'
  },

  description: {
    logoRule: 'Authorized JPG, JPEG or PNG formats. Maximum logo size 800 KB ',
    generalInfo: 'This box displays the general information of the company.',
    telInfo: 'In this box the company contact information is displayed.',
    financialInfo: 'This box displays the company financial information.'
  },

  buttons: {
    save: 'Save changes',
    reset: 'Undo changes',
    removeLogo: 'Remove Logo',
    uploadLogo: 'Load Logo'
  },

  validators: {
    imageSize: 'The selected file size is too large',
    fileFormat: 'The selected file format is not allowed',
    name: 'Name is not valid'
  },

  notifications: {
    logo: {
      upload: {
        success: 'Uploading the logo succeed'
      },
      delete: {
        success: 'Deleting the logo succeed'
      }
    },

    insert: {
      success: 'Creating the company succeed'
    },

    edit: {
      success: 'Updating the company succeed'
    }
  },

  company: {
    title: 'Company'
  },

  insert: {
    title: 'Add Company'
  },

  edit: {
    title: 'Edit Company Information'
  }
}
